import React, { useEffect, useState } from "react";
import * as S from "./styles";
import RoundInput from "@/components/RoundInput";
import { FutButton } from "@/components/FutButton";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  PASSWORD_MATCH,
  REQUIRED_FIELD,
  STRONG_PASSWORD,
} from "@/constants/yupErrors";
import { passwordRegex } from "@/utils/regex";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { api } from "@/services/api";
import jwtDecode from "jwt-decode";
import { IDecodedJwt } from "@/interfaces/jwtDecoded";
import { toast } from "react-toastify";
import { useAuth } from "@/context/AuthContext";
import { catchError } from "@/utils/catchError";

const passSchema = yup.object({
  newPassword: yup
    .string()
    .required(REQUIRED_FIELD)
    .matches(passwordRegex, STRONG_PASSWORD),
  repeatPass: yup
    .string()
    .required(REQUIRED_FIELD)
    .oneOf([yup.ref("newPassword")], PASSWORD_MATCH),
});

type IPassForm = yup.InferType<typeof passSchema>;

export default function ResetPassword() {
  const changePassForm = useForm<IPassForm>({
    resolver: yupResolver(passSchema),
  });
  const { changeToken } = useAuth()
  const changePassError = changePassForm.formState.errors;
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const decodedToken = jwtDecode(token!) as IDecodedJwt;

  useEffect(() => {
    changeToken(token!)
  }, [])

  const submitChangePass = async (data: IPassForm) => {
    try {
      setLoading(true)
      const response = await api.put("/user/reset", {
        email: decodedToken.email,
        newPassword: data.newPassword,
      });
      const newToken = response.data.token

      if (newToken) {
        changeToken(newToken)
      }
      navigate("/dashboard")
      toast.success("Senha alterada com sucesso!")
      setLoading(false)
    } catch (e) {
      const message = catchError(e);
      if (message) {
        toast.error(message);
        return;
      }
      toast.error("Ocorreu um erro ao tentar mudar a senha")
    }
  };
  return (
    <S.ChangeWrapper>
      <S.ChangePassContainer>
        <S.HeaderCreditModal>
          <p>Trocar Senha</p>
        </S.HeaderCreditModal>
        <S.ChangePassInputs
          onSubmit={changePassForm.handleSubmit(submitChangePass)}
        >
          <RoundInput
            inputName="newPassword"
            control={changePassForm.control}
            type="password"
            size="small"
            fullWidth
            topLabel="Senha Nova"
            errorText={changePassError.newPassword}
          />
          <RoundInput
            inputName="repeatPass"
            control={changePassForm.control}
            type="password"
            size="small"
            fullWidth
            topLabel="Confirmar Senha Nova"
            errorText={changePassError.repeatPass}
          />
          <FutButton fullWidth isLoading={loading} sx={{ mt: 4 }} type="submit">
            Salvar
          </FutButton>
        </S.ChangePassInputs>
      </S.ChangePassContainer>
    </S.ChangeWrapper>
  );
}
